package com.appcreator.blueprint.core.properties

import kotlinx.serialization.Serializable

@Serializable
data class ScriptContent(
    val script: String
)

